import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { createPortal } from "react-dom";
import { Toaster } from "react-hot-toast";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

import App from "./App";
import store from "./Redux/index";
import "./index.scss";

const root = ReactDOM.createRoot(document.getElementById("root"));
const overlay = document.getElementById("overlay");
root.render(
  <>
    <BrowserRouter basename={window.env.BASENAME}>
      <Provider store={store} >
        {createPortal(<Toaster />, overlay)}
        <App />
      </Provider>
    </BrowserRouter>
  </>
);

serviceWorkerRegistration.unregister();
//serviceWorkerRegistration.register();   /////new testing  added for remove the error in pwa builder.
